module.exports = __webpack_public_path__ + "img/gzh.2aea1c4d.jpg";